import { Text, Heading } from "../../components";
import InnovativeCultureSection from "../../components/InnovativeCultureSection";
import React, { Suspense } from "react";

const careerFeaturesList = [
  {
    headingText: "Innovative Culture",
    descriptionText:
      "At Zwilling Labs, we believe that innovation drives progress. Our team is encouraged to think outside the box, explore new ideas, and contribute to cutting-edge projects that shape the future of manufacturing.",
  },
  {
    headingText: "Career Growth",
    descriptionText:
      "We prioritize the professional development of our employees. With access to training, mentorship programs, and opportunities for advancement, we support your career journey every step of the way.",
  },
  {
    headingText: "Impactful Work",
    descriptionText:
      "Your contributions will make a difference! At Zwilling Labs, you’ll work on projects that have real-world applications, helping businesses optimize their operations and drive efficiencies through Digital Twin technology.",
  },
];

export default function CareerSection() {
  return (
    <>
      {/* career section */}
      <div className="mt-[140px] flex flex-col items-center">
        <div className="container-xs flex flex-col gap-[122px] px-2.5 md:gap-[91px] md:px-[60px] sm:gap-[61px] sm:px-5">
          <div className="ml-28 mr-[122px] flex flex-col items-center gap-3.5 md:mx-0">
            <a href="careers" target="_blank" rel="noreferrer" className="md:text-[22px] sm:text-[18px]">
              <Heading
                size="heading7xl"
                as="h1"
                className="text-[24px] font-bold uppercase tracking-[2.40px] text-amber-800_01"
              >
                careers
              </Heading>
            </a>
            <div className="flex flex-col gap-6 self-stretch">
              <Heading
                as="h2"
                className="text-center text-[46px] font-bold leading-[69px] text-color_style-01_neutrals-grey800 md:text-[42px] sm:text-[24px] sm:leading-[34px]"
              >
                Your journey with us is just beginning, Join us!
              </Heading>
              <Text
                size="text11xl"
                as="p"
                className="text-center text-[26px] font-normal leading-10 text-muted md:text-[24px] sm:text-[18px] sm:leading-6"
              >
                Start a new chapter with us, where your talents and ambitions will thrive in an environment dedicated to
                growth, collaboration, and excellence.
              </Text>
            </div>
          </div>
          <div className="mr-2.5 rounded-[22px] bg-color_white-a700_07 p-[38px] shadow-md md:mr-0 sm:p-5">
            {/* Use grid system for responsive layout */}
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-[46px]">
              <Suspense fallback={<div>Loading feed...</div>}>
                {careerFeaturesList.map((d, index) => (
                  <InnovativeCultureSection {...d} key={"careerList" + index} className="w-full" />
                ))}
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
